import React from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import useAnimatedNavToggler from "../../helpers/useAnimatedNavToggler";

import logo from "../../images/aadi0info-logo.png";
import mail from "../../images/mail.svg"
import { ReactComponent as MenuIcon } from "feather-icons/dist/icons/menu.svg";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";

const Header = tw.header`
  fixed top-0 left-0 w-full z-50
  flex justify-between items-center
  max-w-screen-xl mx-auto px-4 pt-0 py-1
  bg-gray-200 
  shadow-md 
  
`;

export const NavLinks = tw.div`inline-block`;

export const NavLink = tw.a`
  text-black my-2 lg:text-xl lg:mx-6 lg:my-0 
   tracking-wide transition duration-300
   border-b-2 border-transparent hover:border-primary-800 
`;

export const PrimaryLink = tw(NavLink)`
  lg:mx-0 mt-4
  px-8 py-3 rounded-full bg-white text-black
  hocus:bg-white hocus:text-black focus:shadow-outline font-bold
  border-b-0
  
`;

const LogoLink = styled(NavLink)`
  ${tw`flex items-center font-black text-black border-b-0 text-2xl! ml-0!`}
  img {
    ${tw`w-64`}
  }
`;

const LogoRight = styled(NavLink)`
  ${tw`flex items-center gap-1 font-black font-normal border-b-0 text-xl! ml-0!`}
  img {
    ${tw`w-8 ml-3 cursor-pointer`}
  }
`;
const LogoText = tw.h5`
  text-2xl sm:text-base md:text-lg lg:text-xl xl:text-3xl
  ml-2 font-black text-blue-800
`;

export const MobileNavLinksContainer = tw.nav`flex flex-1 items-center  justify-between`;
export const NavToggle = tw.button`
  lg:hidden z-20 focus:outline-none hover:text-primary-500 transition duration-300
`;
export const MobileNavLinks = motion(styled.div`
  ${tw`lg:hidden z-10 fixed top-0 inset-x-0 mx-4 my-6 p-8 border text-center rounded-lg text-gray-800 bg-white`}
  ${NavLinks} {
    ${tw`flex flex-col items-center text-blue-800`}
  }
`);

export const DesktopNavLinks = styled.nav`
  ${tw`hidden lg:flex flex-1 justify-between items-center`}
  a {
    ${tw`text-blue-800 hover:text-blue-800`}
  }
`;

export default ({
  logoLink,
  links,
  className,
  collapseBreakpointClass = "lg",
}) => {

  const { showNavLinks, animation, toggleNavbar } = useAnimatedNavToggler();
  const collapseBreakpointCss = collapseBreakPointCssMap[collapseBreakpointClass];

  const defaultLogoLeft = (
    <LogoLink href="/">
      <img src={logo} alt="logo" />
      {/* <LogoText>Aadi Info Solutions</LogoText> */}
    </LogoLink>
  );

  const defaultLogoRight = (

    <LogoRight>
    <img src={mail} alt="Email Icon"  onClick={() =>
          window.open("https://mail.google.com/mail/?view=cm&to=hr_india@aadiinfosolutions.com", "_blank")
        }/>
    </LogoRight>

  );

  logoLink = logoLink || defaultLogoLeft;
  links = links

  return (
    <Header className={className || "header-light"} style={{paddingTop:'4px'}}>
      <DesktopNavLinks css={collapseBreakpointCss.desktopNavLinks}>
        {logoLink}
        {links}
        {defaultLogoRight}
      </DesktopNavLinks>

      <MobileNavLinksContainer css={collapseBreakpointCss.mobileNavLinksContainer}>
        {logoLink}
       
        <MobileNavLinks
  initial={{ x: "150%", display: "none" }}
  animate={animation}
  css={collapseBreakpointCss.mobileNavLinks}
  onClick={toggleNavbar}
>
  
    {links}
    <div tw="mx-24 px-4 ">{defaultLogoRight}</div>
  
</MobileNavLinks>

        <NavToggle onClick={toggleNavbar} className={showNavLinks ? "open" : "closed"}>
          {showNavLinks ? <CloseIcon tw="w-6 h-6 text-black mr-4" /> : <MenuIcon tw="w-6 h-6 text-black" />}
        </NavToggle>
      </MobileNavLinksContainer>
    </Header>
  );
};

const collapseBreakPointCssMap = {
  sm: {
    mobileNavLinks: tw`sm:hidden`,
    desktopNavLinks: tw`sm:flex`,
    mobileNavLinksContainer: tw`sm:hidden`,
  },
  md: {
    mobileNavLinks: tw`md:hidden`,
    desktopNavLinks: tw`md:flex`,
    mobileNavLinksContainer: tw`md:hidden`,
  },
  lg: {
    mobileNavLinks: tw`lg:hidden`,
    desktopNavLinks: tw`lg:flex`,
    mobileNavLinksContainer: tw`lg:hidden`,
  },
  xl: {
    mobileNavLinks: tw`xl:hidden`,
    desktopNavLinks: tw`xl:flex`,
    mobileNavLinksContainer: tw`xl:hidden`,
  },
};
